import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';

/** Letters and digits only. */
const ALPHANUMERIC_PATTERN = /^[a-zA-Z0-9]*$/;

/**
 * Restricts input to alphanumeric characters (keypress + paste).
 * Pass `false` to disable without removing the attribute.
 */
@Directive({
    selector: '[ancAlphaNumericOnly]',
    standalone: true
})
export class AncAlphaNumericOnlyDirective {
    /** When false, the directive is inert. */
    ancAlphaNumericOnly = input(true);

    private readonly elementRef = inject(ElementRef<HTMLInputElement>);

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent): void {
        if (!this.ancAlphaNumericOnly()) {
            return;
        }

        const char = event.key;

        if (event.ctrlKey || event.metaKey || char.length !== 1) {
            return;
        }

        if (!/^[a-zA-Z0-9]$/.test(char)) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        if (!this.ancAlphaNumericOnly()) {
            return;
        }

        const current = this.elementRef.nativeElement.value;
        const pastedText = event.clipboardData?.getData('text') ?? '';
        const inputText = current.concat(pastedText);

        if (!ALPHANUMERIC_PATTERN.test(inputText)) {
            event.preventDefault();
        }
    }
}
